import action from 'app/lib/action';
import {DELETE_DOC} from '../constants/actionTypes';

export default {
    request : (utrac, id) => action(DELETE_DOC.REQUEST)({utrac, id}),
    success : (id) => action(DELETE_DOC.SUCCESS)({id}),
    error   : (error) => action(DELETE_DOC.ERROR)({error})
};